import _ from 'lodash';
import { injectService } from '@/inversify.config';
import { i18nSymbol } from '@/i18n';
export const name = 'PATENT_TYPE.render';
function renderDefault(h, renderOpts, params) {
    const { row, column } = params;
    const prop = _.get(column, 'property');
    const { _highlightMixin_hlText } = renderOpts;
    const cellValue = _.get(row, prop);
    let type = <span>-</span>;
    if (cellValue) {
        type = <span 
        // @ts-ignore
        domProps={{
                innerHTML: _highlightMixin_hlText(this.$t(`snapBusiness.dbSelector.${cellValue}`)),
            }}/>;
    }
    return [
        <div class="xtable-cell-render" cell-type={prop} cell-render={name}>
            {type}
        </div>,
    ];
}
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    const { row, column } = params;
    const i18n = injectService(i18nSymbol);
    return i18n.t(`snapBusiness.dbSelector.${row[column.property]}`);
}
export default {
    renderDefault,
    exportMethod,
};
